export const CURRENCY_INR = "INR";